//領収書画面
import { BaseSyntheticEvent, useContext, useEffect, useState } from "react";
import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import { useForm, SubmitHandler, Controller, useFieldArray } from "react-hook-form";
import { HttpPostData, DownloadFile, JumpPage } from "../../../common/Util";
import { LoginStateConext } from "../../../context/AuthContext";
import { TitleParamContext } from "../../../context/TitleContext";
import { OnsiteProgress, CenterBox, OnsiteTextField } from "../../../customelements/CustomInput";
import { LicenseDatas, ReceiptListRow, UserManager_DownloadReceiptFile_Request } from "../../../common/Types";
import * as Yup from "yup";
import { ReciptAtenaValidation } from "../../../common/Valitation";
import market from "../../../css/market.module.scss";
import base from "../../../css/base.module.css"

export interface IFormInputs {
    receiptList: ReceiptListRow[]
}

export type ResponseParam = {
    list: ReceiptListRow[]
}

export type ResponseParam2 = {
    data: LicenseDatas
}

export const Receipt = () => {
    const navigate = useNavigate();
    const [dataList, setDataList] = useState<IFormInputs>({ receiptList: [] });
    const loginState = useContext(LoginStateConext);
    const titleContext = useContext(TitleParamContext);

    const [open, setOpen] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [isDownLoading, setIsDownLoading] = useState<boolean>(false);
    const [dialogParam, setDialogParam] = useState<ReceiptListRow>();
    const [atena, setAtena] = useState<string>();
    const [dialogError, setDialogError] = useState<string>();

    const handleClickOpen = (rowParam: ReceiptListRow) => {
        setAtena(rowParam.atena);
        setDialogError("");
        setDialogParam(rowParam);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const location = useLocation();

    const { register, handleSubmit, control, watch, formState: { isValid }, reset } = useForm<IFormInputs>({
        defaultValues: {
            receiptList: dataList.receiptList
        },
        //resolver: yupResolver(productData?.data.isDelivery ? addressSchema : schema),
        mode: "onChange",
        reValidateMode: "onChange",
    });

    const { fields } = useFieldArray({
        name: "receiptList",
        control: control,
    });

    const watchFieldArray = watch("receiptList");
    const controlledFields = fields.map((field, index) => {
        return {
            ...field,
            ...watchFieldArray[index]
        };
    });

    const onSubmit: SubmitHandler<IFormInputs> = async (data: IFormInputs, event?: BaseSyntheticEvent) => {
        /*await HttpPostData<ResponseParam>("/UserManager/ReceiptListRow",
            data.receiptList.map((value, index, array) => { return { UserLicenseId: value.purchaseHistoryId } })
            , setIsLoading)
            .then((response) => {
                //setDataList(response.data.data);
                return response.data.list;
            })
            .then((result) => {
                reset({ receiptList: result })
            })
            .catch(e => {
                console.log(e);
            });*/
        //InitData();
    }

    const schema = Yup.object({
        atenaValidate: ReciptAtenaValidation,
    }).required();

    useEffect(() => {
        (async () => {
            titleContext.setParamData({ mainTitle: "サポート・製品購入", firstSubTitle: "領収書発行", secondSubTitle: "" });
            await InitData();
        })()
    }, []);

    async function InitData() {
        await HttpPostData<ResponseParam>("/UserManager/GetUserReceiptList", { Email: loginState.loginInfo.email }, setIsLoading
        ).then((response) => {
            reset({ receiptList: response.data.list })
        }).catch(e => {
            console.log(e);
        });
    }

    return (
        <>
            <form onSubmit={handleSubmit(onSubmit)}>
                {isLoading ?
                    <CenterBox>
                        <OnsiteProgress></OnsiteProgress>
                    </CenterBox>
                    :
                    <section className={market.marketArea}>
                        <div className={market.marketAreaInner}>
                            <section className={base.forPc}>
                                <table className={base.pcTable} style={{ width: "80%" }}>
                                    <colgroup>
                                        <col width="20%" />
                                        <col width="38%" />
                                        <col width="10%" />
                                        <col width="20%" />
                                        <col width="12%" />
                                    </colgroup>
                                    <thead>
                                        <tr>
                                            <th>支払日</th>
                                            <th>商品</th>
                                            <th>数量</th>
                                            <th>金額（税込）</th>
                                            <th>領収書（PDF）</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {fields.map((row, index) => {
                                            return (
                                                <tr>
                                                    <td>{row.purchaseDateStr}</td>
                                                    <td>{row.productName}</td>
                                                    <td>{row.quantity}</td>
                                                    <td>{row.displayIncludeTaxPrice}</td>
                                                    <td>
                                                        <Controller
                                                            control={control}
                                                            name={`receiptList.${index}.isIssue`}
                                                            render={({ field, fieldState, formState }) => (
                                                                <>
                                                                    <button
                                                                        className={market.tableButton}
                                                                        disabled={isDownLoading}
                                                                        {...register(`receiptList.${index}.isIssue` as const)}
                                                                        onClick={
                                                                            (e) => {
                                                                                if (row.isIssue) {
                                                                                    handleClickOpen(row);
                                                                                } else {
                                                                                    DownloadFile("/UserManager/DownloadReceiptFile", { purchaseHistoryId: row.purchaseHistoryId, atena: "", isUpdateAtena: false } as UserManager_DownloadReceiptFile_Request, setIsDownLoading)
                                                                                        .catch(e => {
                                                                                        });
                                                                                }
                                                                            }
                                                                        }
                                                                    >{row.isIssue ? "発行" : "再発行"}</button>
                                                                </>
                                                            )}
                                                        />
                                                    </td>
                                                </tr>
                                            );
                                        })
                                        }
                                    </tbody>
                                </table>
                            </section>
                            <section className={base.forSp}>
                                <table className={base.spTable} style={{ width: "100%" }}>
                                    <thead>
                                        <tr>
                                            <th>支払日</th>
                                            <th>商品</th>
                                            <th>数量</th>
                                            <th>金額<br />（税込）</th>
                                            <th>領収書<br />（PDF）</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {fields.map((row, index) => {
                                            return (
                                                <tr>
                                                    <td>{row.purchaseDateStr}</td>
                                                    <td>{row.productName}</td>
                                                    <td>{row.quantity}</td>
                                                    <td>{row.displayIncludeTaxPrice}</td>
                                                    <td>
                                                        <Controller
                                                            control={control}
                                                            name={`receiptList.${index}.isIssue`}
                                                            render={({ field, fieldState, formState }) => (
                                                                <>
                                                                    <button
                                                                        className={market.tableButton}
                                                                        style={{ width: "100%" }}
                                                                        disabled={isDownLoading}
                                                                        {...register(`receiptList.${index}.isIssue` as const)}
                                                                        onClick={
                                                                            (e) => {
                                                                                if (row.isIssue) {
                                                                                    handleClickOpen(row);
                                                                                } else {
                                                                                    DownloadFile("/UserManager/DownloadReceiptFile", { purchaseHistoryId: row.purchaseHistoryId, atena: "", isUpdateAtena: false } as UserManager_DownloadReceiptFile_Request, setIsDownLoading)
                                                                                        .catch(e => {
                                                                                            console.log(e);
                                                                                        });
                                                                                }
                                                                            }
                                                                        }
                                                                    >{row.isIssue ? "発行" : "再発行"}</button>
                                                                </>
                                                            )}
                                                        />
                                                    </td>
                                                </tr>
                                            );
                                        })
                                        }
                                    </tbody>
                                </table>
                            </section>
                            <div className={market.marketFooterArea}>
                                <button style={{ visibility: "hidden" }} className={market.marketButton} disabled={!isValid || isLoading}>登録完了</button>
                                <button className={market.marketButton} type="button" onClick={(e) => { JumpPage("/MyPage", {}, "", navigate); }}>戻る</button>
                                <button style={{ visibility: "hidden" }} className={market.marketButton}>次へ</button>
                            </div>
                        </div>
                    </section>
                }
            </form>
            <Dialog open={open} onClose={handleClose}>
                <DialogTitle sx={{ backgroundColor: "#006485", display: "flex", justifyContent: "center", color: "white", fontSize: 20 }}>領収書の宛名を入力ください</DialogTitle>
                <DialogTitle sx={{ backgroundColor: "#006485", display: "flex", justifyContent: "center", color: "#ffe664", fontSize: 20 }}>※再発行時の宛名の変更はできません。</DialogTitle>
                <DialogContent>
                    <div className={market.marketAreaInner}>
                        <div className={market["layoutBox-l-center"]} style={{ marginBottom:"20px" }}>
                            <div className={market.marketInputTitle} style={{ width: "80px" }}>
                                <h3>宛名</h3>
                            </div>
                            <div style={{ width:"100%" }}>
                                <OnsiteTextField
                                    autoFocus
                                    id="Atena"
                                    type="text"
                                    defaultValue={dialogParam?.atena}
                                    value={atena}
                                    onChange={(e) => { setAtena(e.target.value); }}
                                    sx={{ width:"100%" }}

                                />
                            </div>                            
                        </div>
                        <div className={base.errorMessage}>{dialogError}</div>
                    </div>
                </DialogContent>
                <DialogActions sx={{ height: "50px", marginTop: "20px" }}>
                    <button onClick={handleClose} className={market.dialogButton}>閉じる</button>
                    <button
                        onClick={(e) => {
                            setDialogError("");
                            schema.validate({
                                atenaValidate: atena
                            })
                                .then(function (valid) {
                                    DownloadFile("/UserManager/DownloadReceiptFile", { purchaseHistoryId: dialogParam?.purchaseHistoryId, atena: atena, isUpdateAtena: true } as UserManager_DownloadReceiptFile_Request, setIsDownLoading)
                                        .then(async response => {
                                            await InitData();
                                        })
                                        .catch(e => {
                                            console.log(e);
                                        })
                                        .finally(() => {
                                            handleClose();
                                        });
                                })
                                .catch(function (err) {
                                    setDialogError(err.errors);
                                });
                        
                    }
                    }
                        className={market.dialogButton}
                        disabled={isDownLoading}
                    >ダウンロード</button>
                </DialogActions>
            </Dialog>
        </>
    );
}